export default "__VITE_ASSET__CePp0Pqo__"